module.exports = __webpack_public_path__ + "img/1right-0bfa15bf.png";